import Lenis from 'lenis'

function scrollCtrlVirtual(){

  const $scrollCont = $('.mainpage')
  window.virtualScrollForceDraw = true

  const lenis = new Lenis({
    duration: 1.2,
    easing: function(x){
      return x === 1 ? 1 : 1 - Math.pow(2, -10 * x)
    },
    smooth: true,
    direction: 'vertical',
  })


  //get scroll value
  lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
    bus.emit('scroll')
    bus.emit('scrollupdate')
    if (velocity === 0) {
      bus.emit('scrollend')
    }
    st.eased = st.easedReal = st.current = scroll
  })



  function raf(time) {
    lenis.raf(time*1000)
  }


  function eventOn(){
    //$(window).on('scroll', onScroll)
    bus.on('pageLeaveEnd', eventOff)
    bus.on('raf', raf)
  }
  function eventOff(){
    //$(window).off('scroll', onScroll)
    bus.off('pageLeaveEnd', eventOff)
    bus.off('raf', raf)
  }
  eventOn()
}
export default scrollCtrlVirtual